import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px",
  "data-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-column bgi-no-repeat rounded-top\" style=\"background-image:url(&#39;media/misc/pattern-1.jpg&#39;);\"><h3 class=\"text-white fw-bold px-9 mt-10 mb-6\"> Notifications <span class=\"fs-8 opacity-75 ps-3\">24 reports</span></h3><ul class=\"nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9\"><li class=\"nav-item\"><a class=\"nav-link text-white opacity-75 opacity-state-100 pb-4\" data-bs-toggle=\"tab\" href=\"#kt_topbar_notifications_1\">Alerts</a></li><li class=\"nav-item\"><a class=\"nav-link text-white opacity-75 opacity-state-100 pb-4 active\" data-bs-toggle=\"tab\" href=\"#kt_topbar_notifications_2\">Updates</a></li><li class=\"nav-item\"><a class=\"nav-link text-white opacity-75 opacity-state-100 pb-4\" data-bs-toggle=\"tab\" href=\"#kt_topbar_notifications_3\">Logs</a></li></ul></div>", 1)
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = {
  class: "tab-pane fade",
  id: "kt_topbar_notifications_1",
  role: "tabpanel"
}
const _hoisted_5 = { class: "scroll-y mh-325px my-5 px-8" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "symbol symbol-35px me-4" }
const _hoisted_8 = { class: "mb-0 me-2" }
const _hoisted_9 = {
  href: "#",
  class: "fs-6 text-gray-800 text-hover-primary fw-bolder"
}
const _hoisted_10 = { class: "text-gray-400 fs-7" }
const _hoisted_11 = { class: "badge badge-light fs-8" }
const _hoisted_12 = { class: "py-3 text-center border-top" }
const _hoisted_13 = {
  href: "#",
  class: "btn btn-color-gray-600 btn-active-color-primary"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" View All ")
const _hoisted_15 = { class: "svg-icon svg-icon-5" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", {
  class: "tab-pane fade show active",
  id: "kt_topbar_notifications_2",
  role: "tabpanel"
}, [
  /*#__PURE__*/_createVNode("div", { class: "d-flex flex-column px-9" }, [
    /*#__PURE__*/_createVNode("div", { class: "pt-10 pb-0" }, [
      /*#__PURE__*/_createVNode("h3", { class: "text-dark text-center fw-bolder" }, "Get Pro Access"),
      /*#__PURE__*/_createVNode("div", { class: "text-center text-gray-600 fw-bold pt-1" }, " Outlines keep you honest. They stoping you from amazing poorly about drive "),
      /*#__PURE__*/_createVNode("div", { class: "text-center mt-5 mb-9" }, [
        /*#__PURE__*/_createVNode("a", {
          href: "#",
          class: "btn btn-sm btn-primary px-6",
          "data-bs-toggle": "modal",
          "data-bs-target": "#kt_modal_upgrade_plan"
        }, "Upgrade")
      ])
    ]),
    /*#__PURE__*/_createVNode("img", {
      class: "mw-100 mh-200px",
      alt: "metronic",
      src: "media/illustrations/sketchy-1/1.png"
    })
  ])
], -1)
const _hoisted_17 = {
  class: "tab-pane fade",
  id: "kt_topbar_notifications_3",
  role: "tabpanel"
}
const _hoisted_18 = { class: "scroll-y mh-325px my-5 px-8" }
const _hoisted_19 = { class: "d-flex align-items-center me-2" }
const _hoisted_20 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fw-bold"
}
const _hoisted_21 = { class: "badge badge-light fs-8" }
const _hoisted_22 = { class: "py-3 text-center border-top" }
const _hoisted_23 = {
  href: "#",
  class: "btn btn-color-gray-600 btn-active-color-primary"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" View All ")
const _hoisted_25 = { class: "svg-icon-svg-icon-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data1, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "d-flex flex-stack py-4"
            }, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("span", {
                    class: [`bg-light-${item.state}`, "symbol-label"]
                  }, [
                    _createVNode("span", {
                      class: [`svg-icon-${item.state}`, "svg-icon svg-icon-2"]
                    }, [
                      _createVNode(_component_inline_svg, {
                        src: item.icon
                      }, null, 8, ["src"])
                    ], 2)
                  ], 2)
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode("a", _hoisted_9, _toDisplayString(item.title), 1),
                  _createVNode("div", _hoisted_10, _toDisplayString(item.description), 1)
                ])
              ]),
              _createVNode("span", _hoisted_11, _toDisplayString(item.time), 1)
            ]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("a", _hoisted_13, [
            _hoisted_14,
            _createVNode("span", _hoisted_15, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
            ])
          ])
        ])
      ]),
      _hoisted_16,
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data2, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "d-flex flex-stack py-4"
            }, [
              _createVNode("div", _hoisted_19, [
                _createVNode("span", {
                  class: ["w-70px badge me-4", `badge-light-${item.state}`]
                }, _toDisplayString(item.code), 3),
                _createVNode("a", _hoisted_20, _toDisplayString(item.message), 1)
              ]),
              _createVNode("span", _hoisted_21, _toDisplayString(item.time), 1)
            ]))
          }), 128))
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode("a", _hoisted_23, [
            _hoisted_24,
            _createVNode("span", _hoisted_25, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
            ])
          ])
        ])
      ])
    ])
  ]))
}